const ukTranslation = {
    common: {
        close: "Закрити",
        delete: "Видалити",
        save: "Зберегти",
        add: "Додати",
    },
    currentSpeedIndicator: {
        speedUnit: "км/год",
    },
    diagnostics: {
        buttons: {
            restart: "Перезавантажити ПЗ",
            refresh: "Оновити",
            ping: "Пінг",
            enable: "Увімкнути",
            disable: "Вимкнути",
            restartInterface: "Перезапустити",
            obstructionMap: "Карта перешкод",
        },
        sections: {
            networkStats: "МЕРЕЖЕВА СТАТИСТИКА",
            networkStatsInfo: "Дані про трафік, пропускну здатність та завантаження мережі.",
            cameras: "КАМЕРИ",
            camerasInfo: "Перегляд і керування підключеними камерами.",
            ipRoutes: "IP МАРШРУТИ",
            ipRoutesInfo: "Інформація про активні маршрути та таблицю маршрутизації.",
            networkInterfaces: "МЕРЕЖЕВІ ІНТЕРФЕЙСИ",
            networkInterfacesInfo: "Налаштування та стан підключень мережевих інтерфейсів пристрою.",
            sensors: "ДАТЧИКИ",
            sensorsInfo: "Стан і параметри підключених сенсорів та датчиків.",
            starlink: "STARLINK",
            starlinkInfo: "Стан тарілки Starlink, якість зв'язку та карта перешкод.",
        },
        starlink: {
            updatedAt: "Оновлено",
            latency: "Затримка",
            dropRate: "Втрати",
            throughput: "Пропускна здатність",
            obstructed: "Перешкоди",
            alerts: "Сповіщення",
        },
        table: {
            address: "Адреса",
            status: "Статус",
            id: "Id",
            destination: "Призначення",
            gateway: "Шлюз",
            distance: "Відстань",
            active: "Активний",
            static: "Статичний",
            connected: "Підключений",
            name: "Ім'я",
            type: "Тип",
            running: "Працює",
            disabled: "Вимкнений",
            sensorType: "Тип",
            error: "Помилка",
        },
        pingStats: "{{key}}: втрати {{failed}}%, пінг {{avg}} мс",
    },
    directionController: {
        keyboardSpeedTitle: "Швидкість при керуванні з клавіатури",
        speed25: "25%",
        speed50: "50%",
        speed75: "75%",
        speed100: "100%",
    },
    droneList: {
        deleteModal: {
            title: "Видалити {{name}} зі списку?",
            confirm: "Видалити",
            close: "Закрити",
        },
        alertOperator: {
            message: "Вибачте, але зараз цим дроном керує інший оператор",
            close: "Закрити",
        },
        alertOther: {
            message1: "Зараз цим дроном керує інший оператор",
            message2: "Хочете взяти керуванння на себе?",
            message3: "Введіть ваш пароль для підтвердження",
            passwordLabel: "Пароль",
            requiredError: "Це поле обов'язкове",
            incorrectError: "Пароль невірний",
            submit: "Керувати",
            close: "Закрити",
        },
    },
    droneListItem: {
        onUse: " - На завданні",
        buttons: {
            info: "Інфо",
            viewCameras: "Дивитись камери",
            add: "Додати",
            connect: "Підключитися",
            delete: "Видалити",
            settings: "Налаштування",
            edit: "Редагувати",
            changeClient: "Змінити клієнта",
            starlink: "Starlink",
        },
        editModal: {
            title: "Редагувати",
        },
        changeClientModal: {
            title: "Змінити клієнта",
        },
    },
    droneControl: {
        speedUnit: "км/год",
        armedController: "Активовано пульт",
        disarmedController: "Деактивовано пульт",
        armedKeyboard: "Активовано клавіатуру",
        disarmedKeyboard: "Деактивовано клавіатуру",
        armedScreen: "Активовано екран",
        disarmedScreen: "Деактивовано екран",
        mainVideoQuality: "Звичайна якість відео",
        enhancedVideoQuality: "Покращена якість відео",
        lineStatus: {
            operator: "Оператор",
            drone: "Дрон",
        },
        gatewayLabel: "Поточна система зв'язку:",
        remoteControl: "Віддалене керування",
        modal: {
            controlTaken: "Керування дроном перехоплено командиром",
            close: "Закрити",
        },
    },
    droneControlBottomPanel: {
        buttons: {
            reloadCameras: "Перезавантаження камер",
            openMap: "Відкрити карту",
            reloadGps: "Перезавантаження GPS",
            dayMode: "Денний режим",
            nightMode: "Нічний режим",
            starlink: "Starlink Монітор",
            frontCamera: "Передня камера",
            rearCamera: "Задня камера",
            cameraLightNightOnly: "Підсвітка камери активна тільки в нічному режимі",
            cruiseControl: "Круїзконтроль",
            parkingGrid: "Паркувальна сітка",
            autopilot: "Автопілот",
            exit: "Вийти",
        },
    },
    cruiseControl: {
        hint: "Наберіть швидкість та натисніть кнопку чи перемкніть тумблер E",
        set: "Встановити",
        activeHint: "Круїзконтроль увімкнено, натисніть кнопку стоп або перемкніть тумблер E",
        stop: "СТОП",
    },
    armedStatus: {
        controllerActive: "Активовано пульт",
        controllerInactive: "Деактивовано пульт",
        keyboardActive: "Активовано клавіатуру",
        keyboardInactive: "Деактивовано клавіатуру",
        screenActive: "Активовано екран",
        screenInactive: "Деактивовано екран",
    },
    videoStatus: {
        mainQuality: "Звичайна якість відео",
        enhancedQuality: "Покращена якість відео",
    },
    rollback: {
        title: "Відкат назад при втраті зв'язку",
    },
    droneControlTopPanel: {
        lineStatus: {
            operator: "Оператор",
            drone: "Дрон",
        },
        remoteControl: "Віддалене керування",
        gatewayLabel: "Поточна система зв'язку:",
        pingStats: "{{key}}: втрати {{failed}}%, пінг {{avg}} мс",
    },
    droneForm: {
        labels: {
            name: "Назва *",
            description: "Опис",
            type: "Тип",
            version: "Версія",
        },
        errors: {
            required: "Це поле є обов'язковим",
        },
        submit: "Зберегти",
    },
    changeClientForm: {
        label: "Виберіть клієнта",
        submit: "Зберегти",
    },
    map: {
        contextMenu: {
            addPoint: "Додати точку",
            copyCoordinates: "Скопіювати координати",
        },
    },
    addPointButton: {
        title: "Додати точку",
        modal: {
            title: "Додати точку",
            addButton: "Додати",
            closeButton: "Закрити",
            lat: "Широта",
            lng: "Довгота"
        },
    },
    recenterButton: {
        title: "Де дрон?",
    },
    usersList: {
        roles: {
            admin: "Адмін",
            operator: "Оператор",
        },
        buttons: {
            makeAdmin: "Зробити адміном",
            revokeAdmin: "Зробити оператором",
            resetPassword: "Скинути пароль",
            block: "Заблокувати",
            blocked: "Заблоковано",
            delete: "Видалити",
            add: "Додати",
        },
        deleteModal: {
            title: "Видалити {{name}} зі списку?",
            confirm: "Видалити",
            close: "Закрити",
        },
        resetPasswordModal: {
            title: "Введіть новий пароль",
            newPasswordLabel: "Новий пароль",
            confirmPasswordLabel: "Підтвердіть пароль",
            passwordError: "Це поле обов'язкове і має бути не коротше 8 символів",
            confirmPasswordError: "Підтвердіть новий пароль",
            saveButton: "Зберегти",
            closeButton: "Закрити",
        },
    },
    errors: {
        noServerConnection: "Немає зв'язку із сервером",
    },
    login: {
        title: "Вхід",
        forgotPasswordTitle: "Введіть свій email",
        labels: {
            operator: "Оператор",
            password: "Пароль",
        },
        buttons: {
            enter: "Увійти",
            forgotPassword: "Забули пароль",
        },
        errors: {
            required: "This field is required",
        },
    },
    forgotPassword: {
        successMessage: "Лист з інструкціями відправлено на email",
        emailPlaceholder: "Введіть email",
        errors: {
            emailRequired: "Email обов'язковий",
            emailInvalid: "Некоректний email",
        },
        buttons: {
            backToLogin: "Логін",
        },
        submit: {
            sending: "Відправка...",
            send: "Відновити пароль",
        },
    },
    resetPassword: {
        title: "Скинути пароль",
        labels: {
            newPassword: "Новий пароль",
            confirmPassword: "Підтвердіть пароль",
        },
        errors: {
            passwordRequired: "Пароль обов'язковий",
            minLength: "Мінімум 6 символів",
            confirmRequired: "Підтвердження обов'язкове",
            passwordsMismatch: "Паролі не співпадають",
        },
        submit: {
            saving: "Збереження...",
            save: "Зберегти пароль",
        },
    },
    dashboard: {
        tabs: {
            dronesList: "Список дронів",
            operatorsList: "Список операторів",
        },
        buttons: {
            addDrone: "Додати дрон",
            addOperator: "Додати оператора",
        },
    },
    customers: {
        buttons: {
            addCustomer: "Додати клієнта",
        },
        searchPlaceholder: "Знайти дрон по id",
        noCustomers: "Клієнта не знайдено",
        modal: {
            title: "Додати клієнта",
            label: "Назва",
            addButton: "Додати",
            closeButton: "Закрити",
        },
    },
    createDrone: {
        title: "Додати дрон",
    },
    createUser: {
        title: "Створити оперетора",
        labels: {
            login: "Логін",
            name: "Ім'я",
            role: "Роль",
            password: "Пароль",
            repeatPassword: "Повторіть пароль",
        },
        roles: {
            superAdmin: "Супер Адмін",
            admin: "Адмін",
            serviceAdmin: "Сервісний Адмін",
            operator: "Оператор",
        },
        errors: {
            required: "Це поле є обов'язковим",
        },
        submit: "Додати",
    },
    droneInfoPage: {
        backButton: "⬅ Повернутися до списку дронів",
        info: {
            lastMissionDate: "Дата останньої місії:",
            totalMissionHours: "Загальна кількість годин місії:",
        },
        operatorsSection: {
            title: "Список операторів:",
            addButton: "Додати оператора",
        },
        noRouteData: "Немає данних по маршруту",
        closeButton: "Закрити",
        addOperatorModal: {
            title: "Додати оператора",
        },
    },
    dronesOnline: {
        table: {
            name: "Ім'я",
            number: "Номер",
            type: "Тип",
            status: "Статус",
            customer: "Клієнт",
        },
        onUse: "- На завданні",
        buttons: {
            info: "Інфо",
            settings: "Налаштування",
            viewCameras: "Дивитись камери",
        },
    },
    profile: {
        buttons: {
            changeEmail: "Зінити email",
            addEmail: "Додати email",
            changePassword: "Змінити пароль",
        },
        emailHint: "Щоб зміти пароль спершу додайте email",
        addEmailModal: {
            title: "Додати email",
        },
        changePasswordModal: {
            title: "Зміна паролю",
        },
    },
    changePasswordForm: {
        labels: {
            oldPassword: "Старий пароль",
            newPassword: "Новий пароль",
            confirmPassword: "Підтвердіть пароль",
        },
        errors: {
            oldPasswordRequired: "Старий пароль обов'язковий",
            newPasswordRequired: "Новий пароль обов'язковий",
            newPasswordSameAsOld: "Новий пароль має відрізнятися від старого",
            confirmRequired: "Підтвердження обов'язкове",
            passwordsMismatch: "Паролі не збігаються",
        },
        submit: "Змінити пароль",
    },
    formChangeEmail: {
        labels: {
            email: "Email",
            password: "Пароль",
        },
        errors: {
            emailRequired: "Email обов'язковий",
            emailInvalid: "Некоректний email",
            passwordRequired: "Пароль обов'язковий",
        },
        submit: "Зберегти",
    },
    formCode: {
        label: "Введіть код надісланий на ваш email",
        errors: {
            codeRequired: "Код обов'язковий",
            codeDigitsOnly: "Код має містити тільки цифри",
            codeInvalid: "Код не вірний",
        },
        submit: "Зберегти",
    },
    settingsPage: {
        backButton: "⬅ Повернутися до списку дронів",
        tabs: {
            maintenance: "Обслуговування",
            generalSettings: "Загальні налаштування",
            controllersSettings: "Налаштування контроллерів",
            relaySettings: "Налаштування реле",
            monitor: "Монітор",
            cameraSettings: "Налаштування камер",
        },
        buttons: {
            addRelay: "Додати реле",
            deleteRelay: "Видалити реле",
            saveSettings: "Зберегти налаштування",
        },
        notifications: {
            settingsSaved: "Налаштування збережено",
        },
    },
    connectionSettings: {
        buttons: {
            enableVPN: "Ввімкнути VPN",
            disableVPN: "Вимкнути VPN",
            publishSettings: "Опублікувати налаштування",
        },
        notifications: {
            settingsPublished: "Налаштування опубліковано",
        },
        labels: {
            newDroneId: "Видати цей ID новому дрону",
        },
    },
    serverSettings: {
        labels: {
            enableAutoSwitch: "Увімкнути автоматичне перемикання зв'язку",
            serverAddress: "Адреса сервера",
            serverPort: "Порт сервера",
            apiPath: "Шлях до API",
            pingInterval: "Інтервал пінгу",
            serverTimeout: "Серверний таймаут",
            bmsPort: "Порт BMS",
            gpsPort: "Порт GPS",
            gpsSpeed: "Швидкість GPS",
        },
    },
    controllersSettings: {
        labels: {
            rightBackward: "Нижня ширина імпульсу, правий(мкс)",
            rightStop: "Середня ширина імпульсу, правий(мкс)",
            rightForward: "Верхня ширина імпульсу, правий(мкс)",
            leftBackward: "Нижня ширина імпульсу, лівий(мкс)",
            leftStop: "Середня ширина імпульсу, лівий(мкс)",
            leftForward: "Верхня ширина імпульсу, лівий(мкс)",
        },
    },
    relaySettings: {
        labels: {
            switch: "Перемикач",
            pin: "Пін",
            value: "Значення",
        },
    },
    cameraSettings: {
        labels: {
            adaptiveBitrate: "Адаптивний BITRATE",
        },
        submit: "Зберегти налаштування",
    },
    cameraForm: {
        labels: {
            resolution: "Виберіть разрешение",
            bitrate: "Виберіть BITRATE",
            fps: "Виберіть кількість кадрів в сек (FPS)",
            keyframe: "Виберіть ключовий кадр",
        },
        placeholders: {
            resolution: "-- Выберите разрешение --",
            bitrate: "-- Виберіть BITRATE --",
            fps: "-- Виберіть FPS --",
        },
        errors: {
            resolution: "Виберіть роздільну здатність",
            bitrate: "Виберіть BITRATE",
            fps: "Виберіть FPS",
            keyframe: "Введіть Keyframe",
            keyframeMin: "Значення має бути більше 0",
            keyframeInteger: "Тільки цілі числа",
        },
    },
    cameraView: {
        rotateTitle: "Поверніть телефон",
        rotateText: "Для коректного відображення розгорніть пристрій у горизонтальну орієнтацію.",
        exitButton: "Вийти",
    },
    header: {
        nav: {
            home: "Головна",
            customers: "Клієнти",
            addOperator: "Додати оператора",
            addDrone: "Додати дрон",
            profile: "Профіль",
            dronesOnline: "Дрони онлайн",
            controlGuide: "Довідка",
            logout: "Вихід",
        },
    },
    customer: {
        buttons: {
            select: "Обрати",
            delete: "Видалити",
        },
        deleteModal: {
            title: "Видалити {{name}}?",
            confirm: "Видалити",
            close: "Закрити",
        },
    },
    batteryIndicator: {
        labels: {
            remainingPercent: "Залишок заряду (%):",
            batteryCurrent: "Струм батареї (A):",
            chargeCycles: "Кількість циклів заряду:",
            batteryTemperature: "Температура батареї:",
            batteryVoltage: "Напруга батареї (V):",
            actualCapacity: "Фактична ємність (Ah):",
            boxTemperature: "Температура батарейного боксу:",
            cycleCapacity: "Ємність циклу (Ah):",
            nominalCapacity: "Номінальна ємність (Ah):",
        },
    },
    motorsIndicator: {
        labels: {
            motorData: "Дані двигуна",
            leftRight: "Л / П",
            controllerTemperature: "Температура контролера:",
            motorTemperature: "Температура двигуна:",
            motorCurrent: "Струм двигуна (A):",
            power: "Потужність (%):",
            rpm: "Оберти (об/хв):",
            error: "Помилка:",
        },
    },
    mission: {
        table: {
            missionStart: "Початок місії",
            missionEnd: "Кінець місії",
            operator: "Оператор",
        },
    },
    missionItem: {
        buttons: {
            viewRoute: "Дивитись маршрут",
            downloadGpx: "Скачати GPX трек",
        },
    },
    viewSwitchButton: {
        title: "Змінити тип карти",
    },
    droneControlPanel: {
        modal: {
            controlTaken: "Керування дроном перехоплено командиром",
            close: "Закрити",
        },
    },
    autopilot: {
        modal: {
            title: "Автопілот",
            description: "Вкажіть скільки секунд НРК має рухатись прямо зі швидкістю ~6 км/год.",
            warning: "Увага! У режимі автопілота, за умови наявності перешкод, зв'язок з НРК втрачається, машина рухається самостійно по прямій під кутом, під яким її встановлено. Перед стартом перевірте напрямок і відсутність перешкод — до відновлення зв'язку керування неможливе. Якщо на дорозі є колії чи ями це може збити НРК з прямого курсу. За 1 сек НРК проїде ~1,6 м.",
            seconds: "Секунди",
            startButton: "Старт",
            stopButton: "Стоп",
            closeButton: "Закрити",
            waitConnection: "Дочекайтесь відновлення зв'язку",
        },
    },
    draggableCircle: {
        armed: "Активуйте керування",
    },
    controlGuide: {
        title: "Опис екрану керування",
        intro: "Тут зібрані всі кнопки та позначки екрану керування НРК і пояснення, для чого кожна з них. Функції розділені за датою появи.",
        updateNote: "Якщо на вашому екрані керування немає деяких кнопок з цього списку, зв'яжіться з нами — ми оновимо прошивку вашого НРК.",
        sections: {
            after: "12.10.2026",
            before: "01.01.2026",
        },
        table: {
            button: "Кнопка",
            name: "Назва",
            description: "Що робить",
        },
        items: {
            cruiseControl: {
                name: "Круїзконтроль",
                description: "Функція круїзконтролю — це функція асистованого керування, яка дає змогу НРК автоматично підтримувати швидкість і напрямок руху без постійного утримування стіка газу.\n\nАктивуйте кнопку круїзконтролю. Наберіть потрібну швидкість і натисніть кнопку «Встановити» або перемкніть тумблер на пульті в положення 1 — НРК почне утримувати задану швидкість, стік газу можна відпустити і почати маневрування. Щоб деактивувати функцію круїзконтролю, натисніть «СТОП», перемкніть тумблер у положення 0 або закрийте поле круїзконтролю.\n\nПоки кнопка круїзконтролю підсвічена зеленим — функція активна, сіра — не активна, потребує активації.",
                risksTitle: "Увага!",
                risks: [
                    "При втраті зв'язку НРК виконує команду ще 1 секунду. Після відновлення зв'язку функцію круїзконтролю треба активувати знову: задайте швидкість і переведіть тумблер у положення 1.",
                    "Рекомендується використовувати функцію круїзконтролю на відкритій місцевості, на твердому покритті, зі швидкістю не більше 6–8 км/год.",
                    "Функція круїзконтролю лише підтримує задану швидкість НРК і не розпізнає перешкоди на шляху (дерева, воронки, інженерні загородження, складки рельєфу). Відповідальність за керування НРК несе оператор.",
                ],
                toggleOn: "увімк.",
                toggleOff: "вимк.",
            },
            parkingGrid: {
                name: "Паркувальна сітка",
                description: "Показує приблизні габарити НРК та орієнтовний напрямок руху. За допомогою цих ліній легше оцінити відстань до перешкод та утримувати/прогнозувати вектор руху.",
            },
            separateLight: {
                name: "Підсвітка передньої (П) та задньої (З) камери",
                description: "Ці кнопки дозволяють вмикати та вимикати ІЧ-підсвітку камер. (П) — ІЧ-підсвітка передньої камери, (З) — ІЧ-підсвітка задньої камери.\n\nУвімкнена підсвітка позначається зеленим. Увімкнення/вимкнення ІЧ-підсвітки доступне лише в нічному режимі. У денному режимі кнопки неактивні.",
            },
            autopilot: {
                name: "Автопілот",
                description: "Відкриває віконце автопілота. Вкажіть, скільки секунд НРК має їхати прямо, і натисніть «Старт» — машина поїде сама зі швидкістю приблизно 6 км/год (≈1,6 м за секунду) по прямій у тому напрямку, куди вона зараз повернута. На екрані йде зворотний відлік, зупинити можна кнопкою «Стоп». Важливо: перед стартом перевірте напрямок і чи немає перешкод — поки зв'язок не відновиться, керувати НРК не вийде.",
            },
            remoteControl: {
                name: "Пульт",
                description: "Показує, чи активне керування з пульта. Зелена — пульт керує НРК, сіра — пульт вимкнений. Вмикається і вимикається на самому пульті.",
            },
            keyboard: {
                name: "Клавіатура",
                description: "Вмикає керування НРК з клавіатури комп'ютера. Зелена — увімкнено, сіра — вимкнено. Не вмикається, поки активний пульт.",
            },
            touchscreen: {
                name: "Екран",
                description: "Вмикає керування пальцем на сенсорному екрані (джойстик на відео). Вмикається та вимикається разом із клавіатурою. Не вмикається, поки активний пульт.",
            },
            videoQuality: {
                name: "Якість відео",
                description: "Перемикає якість відео. Звичайна — менше навантаження на зв'язок, відео стабільніше при слабкому сигналі. Покращена (HD) — картинка чіткіша, але потрібен хороший зв'язок.",
            },
            speed: {
                name: "Швидкість",
                description: "Відкриває вибір швидкості для керування з клавіатури: 25%, 50%, 75% або 100%. Обрана швидкість підсвічується. Червоні 100% означають, що зараз увімкнено повний хід.",
            },
            audio: {
                name: "Звук з НРК",
                description: "Вмикає або вимикає звук з мікрофона камери — так ви чуєте, що відбувається біля НРК. Кнопка є лише тоді, коли на камері є мікрофон.",
            },
            microphone: {
                name: "Мікрофон оператора та гучність",
                description: "Вмикає ваш мікрофон — вас буде чути через динамік на НРК. Повзунок над кнопкою змінює гучність динаміка. Кнопка є лише тоді, коли на камері є динамік.",
            },
            cameraLight: {
                name: "Підсвітка камери",
                description: "Вмикає та вимикає світло біля камери, щоб краще бачити в темряві. Працює лише в нічному режимі камери. На НРК з окремою підсвіткою замість неї показуються кнопки «П» і «З».",
            },
            cameraMode: {
                name: "Денний / нічний режим",
                description: "Перемикає камеру між денним і нічним режимом. Нічний режим потрібен у темряві, і лише в ньому можна ввімкнути підсвітку.",
            },
            reloadCameras: {
                name: "Перезавантаження камер",
                description: "Перезапускає камери НРК. Натисніть, якщо відео зависло, зникло або показує чорний екран.",
            },
            map: {
                name: "Карта",
                description: "Відкриває та закриває карту, де видно, де зараз НРК і яким шляхом він проїхав. Вікно карти можна перетягувати та змінювати його розмір.",
            },
            reloadGps: {
                name: "Перезавантаження GPS",
                description: "Перезапускає GPS на НРК. Натисніть, якщо положення на карті не оновлюється або показується неправильно.",
            },
            cameraViews: {
                name: "Вигляд камер",
                description: "Кнопки у правому верхньому куті змінюють, як показано камери: одна камера на весь екран, одна велика і решта маленькими, або всі камери однаково. Обраний вигляд підсвічений.",
            },
            recording: {
                name: "Запис відео",
                description: "Записує відео з передньої та задньої камери. Чорна крапка — почати запис, червоний квадрат — зупинити, пауза — тимчасово призупинити, червона крапка — продовжити. Панель запису можна перетягувати по екрану. Важливо: під час запису відео зберігається не у файл, а всередині браузера. Щоб отримати файли, після зупинки запису натисніть кнопку збереження та виберіть папку на комп'ютері — лише тоді відео опиниться у вас на диску.",
                risksTitle: "Коли відео може бути втрачене:",
                risks: [
                    "Закриття вкладки чи браузера, оновлення сторінки, збій або вимкнення комп'ютера під час запису — запис зупиниться, а останні секунди (а іноді й більше) можуть не зберегтися.",
                    "Приватне вікно (режим інкогніто) — після його закриття всі незбережені відео видаляються.",
                    "Очищення історії, кешу чи даних сайтів у браузері (або програмою для очищення комп'ютера) видаляє всі незбережені відео.",
                    "Відео лежать лише в тому браузері й на тому комп'ютері, де їх записали. З іншого браузера, комп'ютера чи телефону їх не отримати.",
                    "Місце для відео в браузері обмежене. Під час довгого запису воно може закінчитися — тоді запис перестане зберігатися, а браузер може сам видалити старі дані. Зберігайте відео у файли якомога частіше.",
                    "Зберегти відео у файли можна лише в Google Chrome або Microsoft Edge на комп'ютері. В інших браузерах (Firefox, Safari) кнопка збереження не спрацює, і відео залишаться в браузері.",
                    "Якщо у вікні вибору папки натиснути «Скасувати» або не дозволити доступ, нічого не збережеться — відео залишаться в браузері, спробуйте ще раз.",
                    "Після успішного збереження відео видаляються з браузера. Перевірте, що файли з'явилися в обраній папці.",
                    "Під час втрати зв'язку чи зависання відео запис ставиться на паузу — ці моменти не потрапляють у відео. Після перезавантаження камер чи перепідключення запис продовжується окремим файлом; перевірте, що він іде.",
                    "Якщо закрити вкладку, не зупинивши запис, у назві файлу замість часу закінчення буде «unknown».",
                    "Незбережені відео не зникають після виходу з екрану керування — кнопка збереження з'явиться, коли ви наступного разу відкриєте екран керування в цьому ж браузері.",
                    "Файли зберігаються у форматі WebM. Якщо відео не відкривається, спробуйте програму VLC або відкрийте файл у браузері.",
                ],
            },
            connectionStatus: {
                name: "Стан зв'язку",
                description: "Позначки «Оператор» і «Дрон» вгорі екрану. Зелена — зв'язок є, червона — зв'язку немає. Якщо «Дрон» червоний, НРК зараз не отримує команд.",
            },
            exit: {
                name: "Вийти",
                description: "Завершує сеанс керування і повертає на головну сторінку.",
            },
        },
    },
    userPage: {
        backButton: "⬅ Повернутися до списку операторів",
        blockedLabel: "- Заблоковано",
        buttons: {
            addDrone: "Додати дрон",
            blockOperator: "Заблокувати оператора",
        },
        info: {
            lastMissionDate: "Дата останньої місії:",
            totalMissionHours: "Загальна кількість годин місії:",
        },
        dronesSection: {
            title: "Дрони оператора:",
        },
        addDroneModal: {
            title: "Додати дрон",
        },
    },
    notificationInfo: {
        update: "Вийшло нове оновлення",
        reload: "Перезавантаження сервера",
        btnInfo: "Інфо",
        text: "Щоб ознайомитися з оновленням, перейдіть за посиланням нижче або відкрийте розділ «Довідка» в меню.",
    },
    starlinkSettingsPage: {
        common: {
            yes: "Так",
            no: "Ні",
            duration: "{{d}} д {{h}} год {{m}} хв {{s}} с",
            mbps: "{{value}} Мбіт/с",
            ms: "{{value}} мс",
            seconds: "{{value}} с",
            mps: "{{value}} м/с",
        },
        header: {
            title: "Starlink Монітор",
            subtitle: "Статус тарілки · Перешкоди · GPS",
            connected: "Тарілка доступна",
            disconnected: "Тарілка недоступна",
            waiting: "Очікування даних…",
            updatedAt: "Оновлено: {{date}}",
            lastError: "Остання помилка",
        },
        buttons: {
            refresh: "Оновити дані",
            obstructionMap: "Карта перешкод",
        },
        status: {
            label: "Тарілка",
            title: "Статус",
            signalQuality: "Якість сигналу",
            snrAboveNoise: "SNR вище рівня шуму",
            snrBelowNoise: "SNR нижче рівня шуму",
            snrPersistentlyLow: "SNR постійно низький",
            uptime: "Час роботи",
            downlink: "Низхідний",
            uplink: "Висхідний",
            popLatency: "Затримка PoP",
            dropRate: "Частка втрат",
            firstNonemptySlot: "До першого слоту",
            outage: "Останній збій",
            outageSwitched: "з перемиканням",
            alerts: "Активні сповіщення",
            noAlerts: "Немає",
        },
        obstruction: {
            label: "Видимість",
            title: "Перешкоди та орієнтація",
            current: "Зараз",
            obstructed: "Є перешкоди",
            clear: "Чиста видимість",
            fraction: "Частка перешкод",
            time: "Час перешкод",
            boresight: "Азимут / кут місця",
            desiredBoresight: "Бажані азимут / кут місця",
            tilt: "Нахил",
        },
        gps: {
            label: "Термінал",
            title: "GPS",
            valid: "GPS OK",
            invalid: "GPS недійсний",
            satellites: "Супутники: {{count}}",
            position: "Повідомлена позиція",
            altitude: "Висота {{altitude}} м",
            accuracy: "Точність ±{{value}} м",
            horizontalSpeed: "Горизонтальна швидкість",
            verticalSpeed: "Вертикальна швидкість",
            locationUnavailable: "Позиція недоступна. Увімкніть «Allow access on local network» у застосунку Starlink.",
        },
        device: {
            label: "Пристрій",
            title: "Інформація про тарілку",
            deviceId: "ID пристрою",
            hardwareVersion: "Апаратна версія",
            softwareVersion: "Версія ПЗ",
            softwareUpdateState: "Стан оновлення ПЗ",
            ethSpeed: "Швидкість Ethernet",
            mobilityClass: "Клас мобільності",
            classOfService: "Клас обслуговування",
            disablementCode: "Код блокування",
            stowRequested: "Запит на складання",
        },
        obstructionMap: {
            label: "Небо",
            title: "Карта перешкод",
            empty: "Натисніть «Карта перешкод», щоб завантажити дані з тарілки.",
            loading: "Завантаження…",
            refresh: "Оновити",
            help: "Карта показує небо над тарілкою: центр — зеніт, край кола — горизонт. Зелені ділянки — чиста видимість, жовті й червоні — сигнал слабшає через перешкоди (дерева, будівлі тощо). Порожні ділянки — тарілка ще не зібрала там даних. Пунктирне коло — мінімальний кут місця, нижче якого супутники не використовуються. Перешкоди всередині нього погіршують зв'язок.",
            obstructed: "Перешкода",
            clear: "Чисто",
            updatedAt: "Отримано: {{date}}",
            minElevation: "Мінімальний кут місця: {{value}}°",
            referenceFrame: "Система координат: {{value}}",
        },
    },
};
export default ukTranslation;
